import MODE_COLOR_HEXCODES from '@/utils/enum/MODE_COLOR_HEXCODES';

const COLOR_PATHS = [
    {   path: 'error', 
        value: 'ERROR',
    },
    {   path: 'success', 
        value: 'SUCCESS',
    },
    { 
        path: 'primary_font_color', 
        value: 'TEXT',
    },
    {   
        path: 'secondary_font_color', 
        value: 'TEXT_BUTTON',
    },    
]

export default {
    setTheme(val, theme) {
        if (val?.useDarkMode === true) {
            theme.dark = true;
            this.defineColorBlindColors(val, theme, 'dark');
        } else {
            theme.dark = false;
            this.defineColorBlindColors(val, theme, 'light');
        }
        return theme;
    },
    setDefaultColors(mode, scheme, theme) {
        for (let color of COLOR_PATHS) {
            scheme.themes[theme][color.path] = MODE_COLOR_HEXCODES[mode].DEFAULT[color.value];
        }
    },
    defineColorBlindColors(val, scheme, theme) {
        let mode = theme.toUpperCase();

        if (val?.useColorBlindMode === true) {
            for (let color of COLOR_PATHS) {
                scheme.themes[theme][color.path] = MODE_COLOR_HEXCODES[mode].CB[color.value];
            }
        }
        else {
            this.setDefaultColors(mode, scheme, theme);
        }
    }
}